import React, { useEffect, useState } from 'react';
import Web3 from 'web3';


import {
    ButtonProps
} from '@mui/material';


import LoadingButton from '@mui/lab/LoadingButton';
import './index.css';
import Footer from '../../components/footer';



import { styled } from '@mui/material/styles';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import useToken from '../../utils/useToken';
import IssuesGrid from '../../components/issues';

const host_prefix: string = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';


const ColorLoadingButton = styled(LoadingButton)
    <ButtonProps>(({ theme }) => ({
        color: theme.palette.getContrastText("#6e3f3f"),
        borderRadius: 2,
        marginTop: 100,
        justifyContent: 'center',
        backgroundColor: "#6e3f3f",
        '&:hover': {
            backgroundColor: "#110829",
        },
        "&:disabled": {
            backgroundColor: "#7c7c84",
        },
    }));



const UserIssues = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const project_id = searchParams.get('project');
    console.log(`Issues has received params: ${JSON.stringify(searchParams)}`);
    const { token, setToken } = useToken();
    let [issues, setIssues] = useState<[{
        "_id": string,
        "organization_id": string,
        "project_id": string,
        "github_url": string,
        "reward": number,
        "title": string,
        "createdAt": string,
        "updatedAt": string
    }]>();
    useEffect(() => {
        //fetchOrganizations(token);
        async function fetchIssues() {
            console.log('Making request to issues endpoint');
            try {
                const options = {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
                axios.get(`${host_prefix}/api/issues/?project=${project_id}`, options).then(async (res) => {
                    //console.log(res)
                    if (res.data && token) {

                        if (res.data.length > 0) {
                            //console.log(res.data)

                            setIssues(res.data);
                        }
                    }
                })
            } catch (error) {
                console.log('Welcome redirect error: ' + error);
            }
        }

        fetchIssues();
    }, []);


    if (issues) {
        //console.log(organizations)
        return (
            <React.Fragment>
                <body className="bg-image" >
                    <br /><br /><br /><br /><br />
                    <IssuesGrid issues={issues} />
                    <Footer />
                </body>
            </React.Fragment>
        )
    } else {

        return (
            <React.Fragment>
                <body className="bg-image" >
                    <img src={require('./../../images/logo_cropped.png')} className="logo" />
                    <br />
                    <ColorLoadingButton
                        size="small"
                        type="submit"
                        loadingIndicator="Loading..."
                        variant="outlined">
                        Connect with Github
                    </ColorLoadingButton>
                    <Footer />
                </body>
            </React.Fragment>
        )
    }
}

export default UserIssues;